import React from 'react';

/**
 * AppSection - The Public Benefits section
 * Exact content from original index.html
 */
function AppSection() {
  return (
    <section id="app">
      <div className="container">
        {/* Heading */}
        <div className="row">
          <div className="col-md-12 text-center wow fadeIn">
            <div className="title d-inline-block">
              <h6 className="mb-3">Both entities have needs met while</h6>
              <h2 className="gradient-text1 mb-3">The Public Benefits</h2>
              <p>
                Connecting curtailable compute to publicly owned power for public benefit. 
                Orchestrated to meet the power cost requirements for the datacenter, while 
                the utility gains the ability to throttle consumption as needed to maximize 
                grid stability and monetization of generation builds required by the greater 
                power network.
              </p>
            </div>
          </div>
        </div>

        {/* App detail */}
        <div className="row align-items-center text-center">
          
          <div className="col-md-4 wow fadeInLeft">
            {/* App detail item */}
            <div className="app-feature">
              <i className="fa fa-money gradient-text1" aria-hidden="true"></i>
              <h4 className="mb-3">Sell Capacity</h4>
              <p>
                It needed to be built. It was paid for. Now monetize it. 
                Recoup costs and stay in control of local grid deployment.
              </p>
            </div>
            {/* App detail item */}
            <div className="app-feature">
              <i className="fa fa-gears gradient-text1" aria-hidden="true"></i>
              <h4 className="mb-3">Avoid Shutdowns</h4>
              <p>
                When units are not called upon and require shut down, costs mount and 
                failure risks spike. Minimize shutdowns.
              </p>
            </div>
          </div>

          {/* app slider */}
          <div className="col-md-4 wow fadeInUp">
            {/* app Image */}
            <div className="app-image">
              <img src="images/turbine.png" alt="image" />
              {/* Preserved commented carousel for future use */}
              {/*<div id="app-slider" className="owl-carousel owl-theme">
                  <div className="item">
                      <img src="images/iphone-slide1.jpg" alt="" />
                  </div>
                  <div className="item">
                      <img src="images/iphone-slide2.jpg" alt="" />
                  </div>
                  <div className="item">
                      <img src="images/iphone-slide3.jpg" alt="" />
                  </div>
              </div>*/}
            </div>
          </div>

          <div className="col-md-4 wow fadeInRight">
            {/* App detail item */}
            <div className="app-feature">
              <i className="fa fa-bolt gradient-text1" aria-hidden="true"></i>
              <h4 className="mb-3">Large Loads Beckon</h4>
              <p>
                High Power Compute demands are spiking across the grid. 
                Make sure you stay in control of curtailments and grid load.
              </p>
            </div>
            {/* App detail item */}
            <div className="app-feature">
              <i className="fa fa-users gradient-text1" aria-hidden="true"></i>
              <h4 className="mb-3">Partnership Drivers</h4>
              <p>
                Datacenters seek unused, stranded, and cheaper power. 
                Utilities seek grid reliability and covered costs. DataFlex delivers.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}

export default AppSection;